import * as React from "react";
import { forwardRef } from "react";
const SvgDescription = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.5 13L2.5 13M9.5 10L2.5 10M13.5 7L2.5 7M9.5 4L2.5 4", stroke: "#8F979A", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgDescription);
export { ForwardRef as ReactComponent };
